export default __webpack_public_path__ + "fb6d77ebb7375856ecc602b8aeef113a.png";